export sectorsSelector from './sectors-selector';
export formSelector from './form-selector';
export currentAgentSelector from './current-agent-selector';
export currentAccountSelector from './current-account-selector';
export projectsSelector from './projects-selector';
export projectSelector from './project-selector';
export reportsSelector from './reports-selector';
export tasksSelector from './tasks-selector';
export taskFormsSelector from './task-forms-selector';
export submissionsSelector from './submissions-selector';



// WEBPACK FOOTER //
// ./src/selectors/index.js